import $ from 'qwery';

const NavGlobal = {

    $page: $('html'), //this should eventually be replaced by a more centralized reference
    pageActiveClass: 'is-navInView',

    $el: $('[data-navglobal]'),
    $toggleBtn: $('[data-navglobal-toggle]'),

    init: function () {
        if (this.$toggleBtn.length > 0) {
            this.$toggleBtn[0].addEventListener('click', this.toggle);
        }
    },

    toggle: function () {
        NavGlobal.$page[0].classList.toggle('is-navInView');
        setTimeout(NavGlobal.forceRepaint, 400);
    },

    // Bug in some browsers requires forced repaint to display correctly
    forceRepaint: function () {
        var navEl = NavGlobal.$el[0];

        navEl.style.display = 'none';
        navEl.offsetHeight; // no need to store this anywhere, the reference is enough
        navEl.style.display = '';
    }
};

//this will be exported eventually when we move this in to the module loader
export default NavGlobal;
